export default function Loading() {
    return (
        <div className="page-loader">
            <div className="spinner-icon"></div>
        </div>
    );
}
